import { render, staticRenderFns } from "./creditTypeSetting.vue?vue&type=template&id=1f0b20d0&scoped=true"
import script from "./creditTypeSetting.vue?vue&type=script&lang=js"
export * from "./creditTypeSetting.vue?vue&type=script&lang=js"
import style0 from "./creditTypeSetting.vue?vue&type=style&index=0&id=1f0b20d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0b20d0",
  null
  
)

export default component.exports